module.exports = __webpack_public_path__ + "media/别吃鸡.ad665b37.mp4";